<div class="text-override text-atom-component">
  <div [innerHTML]="forceType(content) | safeHtml"></div>
</div>
